import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../../global/mediaQueryMixin';

const Group = styled.div`
  width: 100%;
  margin: auto;
`;

const Container = styled.div`
  display: grid;
  grid-template-rows: auto;
  gap: var(--space-20);
  background-color: var(--background-secondary);
  grid-template-columns: repeat(auto-fill, minmax(191px, 1fr));
  ${mobile_xl(css`
    gap: var(--space-0);
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-12);
    grid-template-columns: repeat(1, 1fr);
    background-color: var(--background-primary);
    overflow: hidden;
  `)}
`;

export { Group, Container };
